import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Exclusive = {
  Wrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 12rem;
    gap: 6rem;
    margin-bottom: 24rem;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      margin-top: 4rem;
      margin-bottom: 7rem;
      overflow-x: hidden;
    }
  `,
  Title: styled.div`
    display: flex;
    gap: 2.6rem;
    font-size: 4rem;
    font-weight: bold;

    & > span:nth-child(3) {
      margin-left: -1.3rem;
    }

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      flex-direction: column;
      line-height: 5rem;
      gap: 0;

      & > span:nth-child(3) {
        margin-left: 0rem;
      }
    }
  `,

  Text: styled.div`
    display: flex;
    padding-left: 4.5rem;
    font-size: 1.8rem;
    margin-top: 2rem;
    line-height: 2.8rem;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      padding-left: 0;
    }
  `,

  Line: styled.img`
    width: 100%;
    height: 4.8rem;
    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      width: 100%;
      height: auto;
      scale: 3;
      overflow: hidden;
    }
  `,
};
